import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { KTIcon, toAbsoluteUrl } from '../../_metronic/helpers';
import { ShowExpenseSheetStatusAsync, getExpenseSheetTotalAmountAsync, getCalculateAmountAndReimburseAsync, updateReimburseCurrencyId } from './expenseSlice';
import clsx from "clsx";
import { formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, setItemStatus, getValueFromResource } from "../../common/timeLiveFunction";
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const ExpenseEntriesNavbar = () => {
    //const { timesheetStatus, totalHours, submittedDate, decimalFormat, nonBillableHours, todayHours, billableHours } = useAppSelector((state) => state.timesheet);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const { obj } = location.state || {};
    const { cultureInfoName, decimalPlaces, sessionAccountEmployeeId ,accountBaseCurrencyId} = useAppSelector((state) => state.globalState)
    const { MasterEmployeeExpenseSheetId,reimbursecurrencyList, ReimburseCurrency,expensesheetDate, expenseEntryList,expenseSheetMasterList, employeeList, AccountEmployeeId } = useAppSelector((state) => state.expense);
    const [labelEmployee, setLabelEmployee] = useState('Not Available');
    const [selectedEmployee, setSelectedEmployee] = useState<{ [object: string]: any }>();
    const currentDate = new Date();
    const [SelectedSheetDate, setSelectedSheetDate] = useState(currentDate);
    const [selectedReimburseCurrency, setSelectedReimburseCurrency] = useState<{ [object: string]: any }>();
    const [labelSheetAmount, setLabelSheetAmount] = useState(FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces));
    //const [labelSheetAmount, setLabelSheetAmount] = useState('0.00');
    const [labelSheetStatus, setSheetStatus] = useState('Not Submitted');
    //const [labelReimburseAmount, setLabelReimburseAmount] = useState('0.00');
    const [labelReimburseAmount, setLabelReimburseAmount] = useState(FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces));
    
    let AccountEmployeeExpenseSheetId = '';
    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;           
    } else if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }

 const RenderExpenseSheetStatus = (Submitted: any, Rejected: any, Approved: any, InApproval: any) => {
        if (!Submitted && !Rejected && !Approved && !InApproval) {
            setSheetStatus (getValueFromResource("Not Submitted", dispatch,t));
        } else if (Submitted && Approved && !Rejected) {
            setSheetStatus(getValueFromResource("Approved", dispatch,t));
        } else if (Rejected && !Submitted) {
            setSheetStatus(getValueFromResource("Rejected", dispatch,t));
        } else if (Submitted && !Rejected && !Approved && InApproval) {
            setSheetStatus(getValueFromResource("Submitted", dispatch,t));
        } else if (Submitted && !Rejected && !Approved && !InApproval) {
            setSheetStatus(getValueFromResource("Submitted", dispatch,t));
        } else if (!Submitted && Approved) {
            setSheetStatus(getValueFromResource("Not Submitted", dispatch,t));
        } else if (!Submitted && InApproval) {
            setSheetStatus(getValueFromResource("Not Submitted", dispatch,t));
        } else if (Submitted && Rejected && Approved && InApproval) {
            setSheetStatus(getValueFromResource("Approved", dispatch,t));
        } else if (Submitted && Rejected) {
            setSheetStatus(getValueFromResource("Submitted", dispatch,t));
        }
    };



    
    useEffect(() => {
        const selectedEmployee = employeeList.find((employee:any) => employee.AccountEmployeeId === AccountEmployeeId);
        if (selectedEmployee) {
          setLabelEmployee(selectedEmployee.EmployeeName);
        } else {
          setLabelEmployee('Not Available');
        }
       const ShowDate:any = moment.parseZone(expensesheetDate).format('YYYY-MM-DD')
       //moment(expensesheetDate).format('YYYY-MM-DD');
        setSelectedSheetDate(ShowDate)
      }, [AccountEmployeeId, employeeList,expensesheetDate]);
   
    useEffect(() => {
      
        if (AccountEmployeeExpenseSheetId !== '') {
            if (Object.keys(expenseSheetMasterList).length > 0) {   
                const ObjexpenseSheetMaster: any = expenseSheetMasterList[0];
                const EmployeeValue = ObjexpenseSheetMaster.AccountEmployeeId;
                setSelectedEmployee({ value: EmployeeValue, label: ObjexpenseSheetMaster.EmployeeName });
                setLabelEmployee(ObjexpenseSheetMaster.EmployeeName);                
                
               
                dispatch(getExpenseSheetTotalAmountAsync(AccountEmployeeExpenseSheetId))
                    .unwrap()
                    .then((originalPromiseResult) => {

                        const sheetAmount =
                            (originalPromiseResult?.CurrencyCode ?? '') +
                            ' ' +
                            (!isNaN(originalPromiseResult?.Amount)
                                ? FormatInvoiceDecimalNumber(
                                    cultureInfoName.toString(),
                                    originalPromiseResult.Amount,
                                    decimalPlaces
                                )
                                : FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces));

                        setLabelSheetAmount(sheetAmount.trim());
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        console.log('Error Expense Sheet Total Amount', rejectedValueOrSerializedError);
                    })
            }
                dispatch(ShowExpenseSheetStatusAsync(AccountEmployeeExpenseSheetId))
                    .unwrap()
                    .then((originalPromiseResult) => {
                      
                        const ExpenseSheetStatus = originalPromiseResult.Data[0]
                        RenderExpenseSheetStatus(ExpenseSheetStatus.Submitted, ExpenseSheetStatus.Rejected, ExpenseSheetStatus.Approved, ExpenseSheetStatus.InApproval);
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        console.log('Error Expense Sheet Total Amount', rejectedValueOrSerializedError);
                    })
            
            if (Object.keys(expenseEntryList).length > 0) {
                const tempObj: any = expenseEntryList[0];
                let ReimburseValue :any = 0;
                if (tempObj.ReimbursementCurrencyId === 0) {
                    const currencyMap = reimbursecurrencyList.reduce((map, item) => {
                        map[item.AccountCurrencyId] = item.CurrencyCode;
                        return map;
                    }, {} as { [key: string]: string });

                    const selectedCurrencyCode = currencyMap[accountBaseCurrencyId.toString()];
                    if (selectedCurrencyCode) {                      
                        dispatch(updateReimburseCurrencyId(accountBaseCurrencyId));
                    }                
                    ReimburseValue = accountBaseCurrencyId;
                } else {
                    ReimburseValue = tempObj.ReimbursementCurrencyId;  
                    setSelectedReimburseCurrency({ value: tempObj.ReimbursementCurrencyId, label: tempObj.ReimbursementCurrencyCode });
                }
                const sheetdate :any = moment.parseZone(tempObj.ExpenseSheetDate).format('YYYY-MM-DD')
                // moment(tempObj.ExpenseSheetDate).format('YYYY-MM-DD');
                setSelectedSheetDate(sheetdate);
                const objReimburse = { "AccountEmployeeExpenseSheetId": AccountEmployeeExpenseSheetId, "ReimbursementCurrencyId": ReimburseValue, "ExpenseSheetDate": sheetdate }
                dispatch(getCalculateAmountAndReimburseAsync(objReimburse))
                    .unwrap()
                    .then((originalPromiseResult) => {   
                        const currency = tempObj.ReimbursementCurrencyCode; 
                        const Reimburs =   (currency ? currency + " " : "") + FormatInvoiceDecimalNumber(cultureInfoName.toString(), originalPromiseResult[0].ReimburseAmount, decimalPlaces);
                        setLabelReimburseAmount(Reimburs);                        
                        
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        console.log('Error Reimburse Calculate Amount', rejectedValueOrSerializedError);
                })
            }else{
                setLabelReimburseAmount( FormatInvoiceDecimalNumber(cultureInfoName.toString(), 0, decimalPlaces));
            }

        }
        else{
        let array: any[] = [];
        employeeList.map(item => {
            array.push({ value: sessionAccountEmployeeId, label: item.EmployeeName })
            if (item != undefined && Number(item.AccountEmployeeId) == sessionAccountEmployeeId) {
                setLabelEmployee(item.EmployeeName);
            }    
        });
       
       
    }
    }, [AccountEmployeeExpenseSheetId,expenseSheetMasterList,expenseEntryList])


    return (
        <>
            <div className="row col-md-15 col-sm-15 col-xs-12 navBarParentDiv">
                <div className='col-md-3 col-sm-3 col-xs-12' style={{ width: '20%' }}>
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-Employee.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Employee`)} */}
                                    {getValueFromResource('Employee',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">{labelEmployee}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' style={{ width: '20%' }}>
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-Date.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Date`)} */}
                                    {getValueFromResource('Date',dispatch, t)}
                                    </a>
                                {/* <span className="fw-bold d-block fs-5 esNavBarInfoText">{moment.parseZone(SelectedSheetDate).format('DD MMM YYYY')}</span> */}
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">{formatDateWithDateAndMonthName(SelectedSheetDate, cultureInfoName.toString())}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' style={{ width: '20%' }}>
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-NonBillable.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Total Amount`)} */}
                                    {getValueFromResource('Total Amount',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">{labelSheetAmount}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' style={{ width: '20%' }}>
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-Status.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Status`)} */}
                                    {getValueFromResource('Status',dispatch, t)}
                                    </a>
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">
                                    <span className={clsx('expenseStatus-td app-navbar-item badge fs-7', setItemStatus(labelSheetStatus))}>
                                        {labelSheetStatus}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-3 col-sm-3 col-xs-12' style={{ width: '20%' }}>
                    <div className='cardInfoShadowExpense'>
                        <div className='esNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-ReimburseAmount.svg')}
                                    />
                                </div>
                            </div>
                            <div className='esNavBarInnerBoxSecondSection'>
                                <a className="text-uppercase tsNavBarInfoLabel">
                                    {/* {t(`Reimbursement Amount`)} */}
                                    {getValueFromResource('Reimbursement Amount',dispatch, t)}
                                    </a>
                                {/* <span className="fw-bold d-block fs-5 esNavBarInfoText">{labelReimburseAmount}</span> */}
                                <span className="fw-bold d-block fs-5 esNavBarInfoText">{labelReimburseAmount}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className='col-md-2.5 col-sm-2 col-xs-12'>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    {timesheetStatus.text == 'Approved' ?
                                        <span className="symbol-label bg-light-info">
                                            <i className="ki-outline ki-notification-status text-info fs-1"></i>
                                        </span> :
                                        <img
                                            src={toAbsoluteUrl('/media/svg/customSVG/icon-Status.svg')}
                                        />
                                    }
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                <span className="fw-bold d-block" style={{ color: '#172b4d', marginBottom: -2.6, marginTop: 5, fontSize: '1.14rem' }}>timesheetStatus</span>
                                <a className="text-uppercase tsNavBarInfoLabel">{`Timesheet Status`}</a>
                            </div>
                        </div>
                    </div>
                </div> */}
        </>
    )
}

export default ExpenseEntriesNavbar